import { render } from "./TemplateSelector.vue?vue&type=template&id=c1e6e182&scoped=true"
import script from "./TemplateSelector.vue?vue&type=script&lang=js"
export * from "./TemplateSelector.vue?vue&type=script&lang=js"

import "./TemplateSelector.vue?vue&type=style&index=0&id=c1e6e182&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e6e182"]])

export default __exports__